var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcStops(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00093 13.5838C5.78277 13.5839 5.57298 13.4999 5.41531 13.3491V13.3483C1.7066 9.76564 0.538086 7.96911 0.538086 5.87944C0.538086 3.44926 2.06076 1.31141 4.39778 0.644837C8.10008 -0.409634 11.4627 2.34259 11.4627 5.87944C11.4627 7.9675 10.2949 9.76484 6.58623 13.3483C6.42877 13.4993 6.21909 13.5836 6.00093 13.5838ZM5.99913 7.8861C7.06363 7.8861 7.92657 7.02316 7.92657 5.95866C7.92657 4.89417 7.06363 4.03122 5.99913 4.03122C4.93464 4.03122 4.07169 4.89417 4.07169 5.95866C4.07169 7.02316 4.93464 7.8861 5.99913 7.8861Z",
    fill: "#B2B8CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStops);
export default __webpack_public_path__ + "static/media/ic_stops.cd8ec637cf7007c51c18fb995859f204.svg";
export { ForwardRef as ReactComponent };